<template>
  <section class="tf-card">
    <div class="tf-card__head">
      <span class="tf-card__icon"><i class="fa fa-code"></i></span>
      <div class="tf-card__titles">
        <h3 class="tf-card__title">Скрипты</h3>
        <p class="tf-card__sub">
          Кто подвешивает браузер: свой код, аналитика, виджеты. Время — в среднем на один просмотр
        </p>
      </div>
    </div>
    <div class="tf-card__body">
      <div v-if="!rows.length" class="an-empty">
        <i class="fa fa-code"></i>
        <span>За период замеров скриптов нет</span>
      </div>
      <div v-else class="an-table-wrap">
        <table class="an-table">
          <thead>
          <tr>
            <th>Источник</th>
            <th class="an-num" title="В какой доле просмотров встретился">Встречается</th>
            <th class="an-num">Файлов на просмотр</th>
            <th class="an-num">Загрузка</th>
            <th class="an-num" title="Сколько главный поток занят его кодом — в это время страница не реагирует">Блокирует поток</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="row in rows" :key="row.host">
            <td>
              {{ row.label }}
              <span v-if="row.host !== row.label" class="an-cell-sub">{{ row.host }}</span>
            </td>
            <td class="an-num">{{ formatPercent(row.viewShare) }}</td>
            <!-- у своего кода сайт меряет только занятость потока -->
            <td class="an-num">{{ row.host === 'self' ? '—' : row.requestsPerView }}</td>
            <td class="an-num">{{ row.host === 'self' ? '—' : formatMs(row.durationPerView) }}</td>
            <td class="an-num">{{ formatMs(row.blockingPerView) }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import {formatMs, formatPercent} from "@/common/rumFormat";

export default {
  name: "RumScripts",
  props: {
    data: {type: Object, required: true},
  },
  computed: {
    // Сайт уже отсортировал: сверху те, кто дольше всего держит поток.
    rows() {
      return this.data.rows || []
    },
  },
  methods: {formatMs, formatPercent},
}
</script>
